jQuery(document).ready(function ($) {
    // Open search
    $('.header__search-button, .main-navigation__search').on('click', function () {
        $('#search-bar').addClass('search-bar--show');
        setTimeout(() => {
            $('.search-field').focus();
        }, 300);
    })

    // Close search
    $('.search-bar__close-button').on('click', function () {
        $('#search-bar').removeClass('search-bar--show');
        setTimeout(() => {
            $('.search-field').blur();
        }, 300);
    })

    $('.search-bar__product-form').submit(function (event) {
        event.preventDefault();

        let searchUrl = $(this).data('search-url');
        let searchValue = $(this).find('input[type="search"]').val();
        let finalSearchUrl = searchUrl + '&custom_search=' + searchValue;

        window.location.href = finalSearchUrl;

        let pathName = window.location.pathname;
        if (pathName.includes('catalogus') && $('body').hasClass('page-template-page-catalog')) {
            console.log('on catalog page');
            window.location.reload();
        }
    });
});
